import { post, get, put, del as requestDel } from '@/utils/request';

// 新增/修改项目
export function ProjectAdd(Data) {
  if (Data.id && Data.id > 0) {
    return put('/api/v1/project/' + Data.id, Data);
  }
  return post('/api/v1/project', Data); 
}

// 项目分页列表
export function ProjectList(Data) {
  return get('/api/v1/project/page', Data); 
}

// 删除项目
export function ProjectDel(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return requestDel('/api/v1/project/' + id); 
}

// 项目详情
export function ProjectDetail(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return get('/api/v1/project/detail', { id }); 
}

// 获取项目下拉选择列表
export function ProjectListSelect() {
  return get('/api/v1/project/list');
}
